const style = {
  select: {
    padding: `5px 15px`,
    width: `250px`,
    height: `40px`,
    overflow: `hidden`,
    background: `#fff`,
    border: `1px solid #666`,
    borderRadius: 0,
    '-webkit-appearance': `none`,
    fontSize: `14px`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Statistics/style/ColorBlind/selector.js